module.exports = __webpack_public_path__ + "img/tu1.9f5a53e8.png";